import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialogStates$ = new BehaviorSubject<Map<string, boolean>>(new Map());

  public openDialog(dialogId: string): void {
    this.setDialogState(dialogId, true);
  }

  public closeDialog(dialogId: string): void {
    this.setDialogState(dialogId, false);
  }

  public isDialogVisible(dialogId: string): Observable<boolean> {
    return this.dialogStates$.asObservable()
      .pipe(
        map((states) => states.get(dialogId) || false),
        distinctUntilChanged(),
      );
  }

  private setDialogState(dialogId: string, isVisible: boolean): void {
    if (!dialogId) {
      console.error('Dialog ID must be provided');
      return;
    }

    const currentStates = this.dialogStates$.getValue();
    currentStates.set(dialogId, isVisible);
    this.dialogStates$.next(new Map(currentStates));
  }
}
